import MultiRangeSlider from "@/components/MultiRangeSlider";
import React from "react";
import MUISlider from "@mui/material/Slider";
import ToggleSwitch from "@/components/ToggleSwitch";
import BtnGroup from "../../shared/BtnGroup";
import { sliderTestIdSlots } from "@/components/sliderTestIdSlots";
import {
  REGIME_SELECTORS_TEST_ID,
  regimeBoundaryThumbName,
} from "@/scorecardKb/testIdCatalog";

const regimeSelectorThumbTestIds = sliderTestIdSlots(
  REGIME_SELECTORS_TEST_ID,
  regimeBoundaryThumbName
);

const RangeSelector = ({
  handleYearChange,
  regimeCount,
  setRegimeCount,
  regimeSelectors,
  dataBar,
  updateRegime,
  onRegimeCommit,
  multiAssetToggle,
  handleMultiAssetToggle,
}) => {
  return (
    <div className="grid grid-cols-12 items-center space-x-0 lg:space-x-10 p-4 md:p-0 text-left mb-4 lg:mb-6 mx-auto w-full lg:w-auto bg-white lg:bg-transparent rounded-lg lg:rounded-0">
      <div className="flex flex-col xl:flex-row col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-4 md:p-4 lg:p-0 md:border-r lg:border-0">
        <label className="font-medium bold mb-2">Period</label>
        <div className="flex flex-col relative w-full items-right justify-right mt-2 px-0 xl:px-4 min-h-8 mb-4 md:mb-0">
          <MultiRangeSlider
            min={1901}
            max={2025}
            onChangeCommitted={({ min, max }) => handleYearChange({ min, max })}
          />
        </div>
      </div>

      <div className="flex flex-col xl:flex-row col-span-12 md:col-span-6 lg:col-span-5 pt-5 pb-2 md:p-4 lg:p-0 md:pb-0 mb-4 md:mb-0 border-y md:border-0">
        <div className="flex items-center me-0 md:me-3">
          <label className="font-medium me-3 bold"> Regimes </label>
          <input
            type="number"
            name="min"
            aria-label="Regime count"
            value={regimeCount + 1}
            min={2}
            max={5}
            className="border border-gray-300 ps-3 py-1 w-16 rounded"
            onChange={(e) => {
              const value = Number(e.target.value);
              if (value >= 2 && value <= 5) {
                setRegimeCount(value - 1);
              }
            }}
            data-testid="main-period-regime-count-input:number"
          />
        </div>

        <MUISlider
          min={regimeSelectors[0]}
          max={regimeSelectors[regimeSelectors.length - 1]}
          value={regimeSelectors.slice(1, -1)}
          valueLabelDisplay={"auto"}
          disableSwap={true}
          onChange={(e, v, t) => {
            let activeThumb = t + 1;
            if (
              regimeSelectors[activeThumb - 1] <= v[t] &&
              v[t] <= regimeSelectors[activeThumb + 1]
            ) {
              updateRegime(v[t], "regime_value_" + activeThumb);
            }
          }}
          onChangeCommitted={() => {
            onRegimeCommit?.();
          }}
          valueLabelFormat={(x) => {
            let year = dataBar?.labels[x - 1];
            let value = dataBar?.datasets[0]?.data[x - 1];
            if (!year || value === undefined || value === null) {
              return "Loading...";
            }
            // Handle both object format { y: number } and raw number format
            const numValue = typeof value === "object" ? value.y : value;
            return (
              (typeof numValue === "number" ? numValue.toFixed(3) : numValue) +
              " of " +
              year
            );
          }}
          track={false}
          data-testid="main-period-regime-selectors-input:range"
          {...regimeSelectorThumbTestIds}
        />
      </div>
      <div className="flex justify-center col-span-12 lg:col-span-4 xl:col-span-3 md:p-4 lg:p-0 md:border-t lg:border-0">
        <BtnGroup
          buttons={[
            { value: "singleAsset", label: "Single Asset" },
            {
              value: "differentAsset",
              label: "Different Assets",
            },
          ]}
          selectedValue={multiAssetToggle}
          onClick={handleMultiAssetToggle}
          className=""
          testIdPrefix="main-period-mode"
        />
      </div>
    </div>
  );
};

export default RangeSelector;
